import { SectionStats } from "@/app/report/common/constructor"
import { TableHeaderColumn } from "@/app/report/common/constructor"
import { TableData } from "@/app/report/common/constructor"
import {
  ROW_LEN_ONE_PAGE_LIMIT,
  TABLE_PER_PAGE_BY_ROW,
  TABLE_PER_PAGE_BY_ROW_FIRST_PAGE,
} from "@/app/report/common/export/constants"
import { DataTable } from "@/app/report/common/type"

const getTableLength = (length: number, isDaily: boolean, LIMIT_PER_PAGE: number[]) => {
  if (length <= 0) {
    return 1
  }

  let totalLenOfSinglePage = 0 // 단일 페이지 안에 있는 테이블들의 row 총 갯수
  const tableLen = length + (isDaily ? 2 : 0) + 1 // 해당 테이블 row 개수 + 데일리 리포트의 total 및 avg 개수 + 헤더 개수

  totalLenOfSinglePage += tableLen

  for (let i = 0; i < LIMIT_PER_PAGE.length; i++) {
    if (totalLenOfSinglePage >= LIMIT_PER_PAGE[i]) {
      return i + 1
    }
  }

  return LIMIT_PER_PAGE.length
}

export const getTablePerPage = (length: number, isDaily = false) =>
  getTableLength(length, isDaily, TABLE_PER_PAGE_BY_ROW)
export const getTablePerPageFirstPg = (length: number, isDaily = false) =>
  getTableLength(length, isDaily, TABLE_PER_PAGE_BY_ROW_FIRST_PAGE)

export function getSplittedByPage({
  splittedTableBody,
  splittedTableHeader,
  isDaily = false,
  isFirst = false,
  data,
  maxLine = 0,
}: {
  splittedTableBody: DataTable[][]
  splittedTableHeader: TableHeaderColumn[][]
  isDaily: boolean
  isFirst: boolean
  data: SectionStats
  maxLine?: number
}): SectionStats[][] {
  const { table } = data
  let flattenBody = []

  for (let rowIterator = 0; rowIterator < splittedTableBody[0]?.length || 0; rowIterator++) {
    const tableBody = splittedTableBody.map((tableBodyList) => tableBodyList[rowIterator])
    flattenBody.push(
      tableBody.map(
        (tableBody) =>
          ({
            ...data,
            table: {
              tableHeader: splittedTableHeader[rowIterator],
              tableBody: tableBody,
            } as unknown as TableData,
          }) as SectionStats,
      ),
    )
  }

  flattenBody = flattenBody.flat()

  const splitByPage = []
  const dataLen = table.tableBody.length
  while (flattenBody.length > 0) {
    if (
      flattenBody[0].table.tableBody.length >= ROW_LEN_ONE_PAGE_LIMIT ||
      (flattenBody[1]?.table.tableBody.length || 0) >= ROW_LEN_ONE_PAGE_LIMIT
    ) {
      splitByPage.push(flattenBody.splice(0, 1))
    } else {
      const tablePerPage = getTablePerPage(dataLen + maxLine, isDaily) || 1

      const tableRowLimit: number =
        isFirst && splitByPage.length === 0
          ? getTablePerPageFirstPg(dataLen, isDaily)
          : tablePerPage
      splitByPage.push(flattenBody.splice(0, tableRowLimit))
    }
  }

  return splitByPage
}

export function getLocaleString(value: number, decimalPoint: number): string {
  return value.toLocaleString(undefined, {
    minimumFractionDigits: decimalPoint,
    maximumFractionDigits: decimalPoint,
  })
}
